<template>
  <div>
    <div
        v-for="option in options"
        :key="option.value"
        class="radio"
    >
      <input
          type="radio"
          class="dot"
          :id="option.value"
          :value="option.value"
          v-model="selected"
      >
      <label
          for="option.value"
          class="text"
      >
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'CustomRadio',

  emits: ['radioChange'],

  props: {
    options: Array,
    initialValue: Boolean,
  },

  setup(props, { emit }) {
    const selected = ref(props.initialValue);

    watch(() => selected.value, () => {
      emit('radioChange', selected.value);
    });

    return {
      selected,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.radio {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;

  .text {
    margin-left: 10px;
  }

  .dot {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid $light-grey;
    border-radius: 50%;

    &:hover {
      box-shadow: 0 0 5px 0 $light-grey inset;
    }

    &:before {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      margin: 4px;
      border-radius: 50%;
    }

    &:checked:before {
      background: $blue;
    }
  }
}
</style>
